export const createHrefValueForPhoneNumber = (phoneNumber: string): string => `tel:${phoneNumber}`;
